export const DOMAIN_NAMES = {
    'FIDUCIAL': 'FIDUCIAL',
    'FIDUCIAL_JADE': 'FIDUCIAL_JADE',
    'FIDUCIAL_FEDERATED': 'FIDUCIAL_FEDERATED'
};
